var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.value === 0
      ? _c("span", [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n    ")])
      : _c("span", [_vm._v("\n        " + _vm._s(_vm.date) + "\n    ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }